import { useMemo } from "react";
import { useGetVodAnalyticsQuery } from "../../store/api/analyticsApi";
import { processDateRangeData } from "../../utils/analytics/processDateRangeData";
import { groupData } from "../../utils/analytics/groupData";

const EMPTY_CHART = {
  xAxis: [],
  yAxis: [],
  percentageChange: 0,
  netValue: 0,
  formattedPercentageChange: "0%",
};

export const useVodAnalytics = ({ params, skip, dateRange, isContentPartner = false }) => {
  const { data: vodData, isFetching } = useGetVodAnalyticsQuery(
    params
      ? {
          pubId: params.pub_id,
          channelId: params.channel_id,
          startDate: params.prev_start_date,
          endDate: params.end_date,
        }
      : {},
    { skip }
  );

  const viewedMinutesData = useMemo(() => {
    if (!vodData || !params) return EMPTY_CHART;
    const raw = processDateRangeData(
      vodData,
      {
        responsePath: "data",
        xAxisKey: "filter_timestamp",
        extractValue: (entry) => entry.duration / 60,
        reverseValues: true,
      },
      params
    );
    return groupData(raw, dateRange);
  }, [vodData, params, dateRange]);

  const viewsData = useMemo(() => {
    if (!vodData || !params || !isContentPartner) return EMPTY_CHART;
    const raw = processDateRangeData(
      vodData,
      {
        responsePath: "data",
        xAxisKey: "filter_timestamp",
        extractValue: (entry) => entry.video_views || 0,
        reverseValues: true,
      },
      params
    );
    return groupData(raw, dateRange);
  }, [vodData, params, dateRange, isContentPartner]);

  return {
    loading: isFetching,
    isFetching,
    viewedMinutesData,
    viewsData,
  };
};

export default useVodAnalytics;
